import axios from "axios";

export const modelApis = {
  getAll: () => {
    return axios
      .get(`/Products/catalog/1000/0`)
      .then((res) => res.data.data.items)
      .catch((e) => console.log(e));
  },
  getByBrand: (url: string) => {
    return axios
      .get(`/Products/catalog/1000/0?${url}`)
      .then((res) => res.data.data.items)
      .catch((e) => console.log(e));
  },
};
